import axios from 'axios'


export const fetchWordpressContent = ({slug, loggedIn}, success, error) => {
    if(loggedIn === undefined) loggedIn = false; //fallback to false if undefined
    loggedIn = false;
    axios.get('https://content.cherrytree.co.nz/wp-json/get_by_custom_slug/' + slug + '/false').then(
        response => {
            const data = response.data
            success(data)
        }
    ).catch(error)
}

export const fetchWordpressPreview = ({ url }, success, error) => {
    axios.get(url, {withCredentials: true}).then(
        response => {
            const data = response.data
            success(data)
        }
    ).catch(error)
}


export const fetchPromoTile = ({slug = "none"}, success) => {
    axios.get('https://content.cherrytree.co.nz/wp-json/wp/v2/promo_tile?filter[promo_tile_location]=' + slug).then(
        response => {
            const data = response.data;
            success(data)
        }
    ).catch((error)=>{
        console.log("error getting promo tile ", error);
        //if it fails, return empty array so nothing shows
        success([])
    })
}

export const fetchBlogPosts = (success) => {
  axios.get('https://content.cherrytree.co.nz/wp-json/wp/v2/posts?_embed').then(
    response => {
      const data = response.data;
      success(data)
    }
  ).catch((error) => {
    console.log("Error Getting Blog Posts: ",error)
    success([])
  })
}

export const fetchSingleBlogPost = (post_id, success,error) => {
  axios.get('https://www.content.cherrytree.co.nz/wp-json/wp/v2/posts/?filter[p]='+post_id).then(
    response => {
      const data = response.data;
      success(data)
    }
  ).catch(error)
}
